import "./aboutus.css";
import { motion } from "framer-motion";
import { fadeVariants } from "../../Animations/fadeVariants.js";
import { useEffect } from "react";

function AboutUs() {
  useEffect(() => {
    const elements = document.querySelectorAll(".slide-left, .slide-right");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("in-view");
          }
        });
      },
      { threshold: 0.5 }
    );

    elements.forEach((el) => observer.observe(el));
  }, []);

  return (
    <motion.div
      variants={fadeVariants}
      initial="initial"
      animate="animate"
      exit="exit"
    >
      <div className="header-1">
        <a href="/" className="home-button">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="24px"
            viewBox="0 -960 960 960"
            width="24px"
            fill="#1f1f1f"
          >
            <path d="M400-80 0-480l400-400 71 71-329 329 329 329-71 71Z" />
          </svg>
        </a>
        <h1 className="header">About Us</h1>
      </div>
      <p className="aboutus-text">
        We’re Kubra and Zack – your local dog-loving duo based in Paulus Hook,
        Jersey City. Since 2022, we’ve been proudly walking, sitting, and caring
        for pups in the neighborhood, turning our love for dogs into a small
        business we truly cherish.{" "}
      </p>
      <img
        src="https://i.imgur.com/z6r19ci.jpeg"
        alt="Kubra and her dog Maya"
        className="kubra-maya slide-left"
      />
      <p className="aboutus-text">
        It all started when I (Kubra) began missing my family dog Maya — a goofy
        golden retriever back home in Turkey. What began as a way to fill that
        furry void quickly turned into something much bigger, and thankfully, my
        husband Zack (a fellow dog lover) jumped in to help as things grew.We’re
        so grateful for the incredible community we’ve built through this work.
      </p>
      <img
        src="https://i.imgur.com/0HnCu1B.jpeg"
        alt="zack and luna"
        className="kubra-maya slide-right"
      />
      <p className="aboutus-text">
        Whether you’re a long-time client (we love you!) or someone looking for
        trustworthy, caring, and fun dog care — we’d be thrilled to meet you and
        your pup!
        <br />
        Feel free to reach out anytime — we’re always happy to chat (especially
        if it involves dogs).
        <br />
        With love,Kubra & Zack
      </p>
      <img src="https://i.imgur.com/v9lLOO6.jpeg" alt="Picture" className="pic-on-bike" />
    </motion.div>
  );
}

export default AboutUs;
